import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";

import { Dialog, Typography } from "@mui/material";

export default function ConfirmDialog(props) {
  const {
    open,
    onClose,
    actionState,
    title,
    action,
    buttonAcceptLabel,
    onSuccess,
  } = props;

  const onClickAccept = (event) => {
    action && action(actionState);
    onSuccess && onSuccess();
    onClose && onClose(event);
  };

  const onCloseCancel = (event) => {
    onClose && onClose(event);
  };

  return (
    <Dialog open={open} onClose={onCloseCancel}>
      <Box padding={2} minWidth={400}>
        <Typography fontSize={20} fontWeight={700}>
          {title}
        </Typography>
        {props.children}
        <Grid container>
          <Grid item xs textAlign="center">
            <Button variant="contained" color="error" onClick={onClickAccept}>
              {buttonAcceptLabel || "実装"}
            </Button>
          </Grid>
          <Grid item xs textAlign="center">
            <Button variant="outlined" onClick={onCloseCancel}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
}
